import { cn } from '@/lib/utils';
import type { CMSPlaceholder } from '../schemas';
import { match, P } from 'ts-pattern';
import { lazy, Suspense } from 'react';
import { FullScreenLoadingSpinner } from '@/components/full-screen-loading-spinner';
import AppLinks from './app-links';
import SocialLinks from './social-links';
import DownloadApp from './download-app';
import { ComparisonTable } from './comparison-table';
import { ExetelLogo } from './exetel-logo';
import type { CMSPlaceholderProps } from './types';

import SpeedTestWrapper from '@/pages/speed-test';
import { SectionLink } from './section-link';
const MobileCoverageMap = lazy(() => import('./mobile-coverage-map'));

// NOTE: this placeholder component will be used to other components similar to the current one - iframe coverage map, the components will be indentified using `name` field.
const CMSPlaceholder = ({
  placeholderData,
  className,
  isFromFooter = false,
}: CMSPlaceholderProps & { isFromFooter?: boolean }) => {
  const name = placeholderData.name;

  return (
    <div className={cn('w-full', className)}>
      {match(name)
        .with('mobile_coverage_map', () => (
          <Suspense fallback={<FullScreenLoadingSpinner />}>
            <div className="w-full container">
              <MobileCoverageMap />
            </div>
          </Suspense>
        ))
        .with('app_links', () => (
          <AppLinks isBlack={isFromFooter} isFromFooter={isFromFooter} />
        ))
        .with('app_links_black', () => <AppLinks isBlack />)
        .with(P.union('app_links_center', 'app_links_centre'), () => (
          <AppLinks isCenter />
        ))
        .with(
          P.union('app_links_center_black', 'app_links_centre_black'),
          () => <AppLinks isCenter isBlack />
        )
        .with('social_links', () => <SocialLinks />)
        .with('download_app', () => <DownloadApp />)
        .with('download_app_black', () => <DownloadApp isBlack />)
        .with(P.union('download_app_center', 'download_app_centre'), () => (
          <DownloadApp isCenter />
        ))
        .with(
          P.union('download_app_center_black', 'download_app_centre_black'),
          () => <DownloadApp isCenter isBlack />
        )
        .with('app_comparison_table', () => <ComparisonTable />)
        .with('exetel_logo', () => <ExetelLogo />)
        .with('exetel_logo_green', () => <ExetelLogo isGreen />)
        .with('speed_test', () => <SpeedTestWrapper />)
        // Add spaces between component it can be used in banner to add more space
        .with('spacer', () => <div className="h-2 md:h-0 lg:h-4"> </div>)
        // For section anchor links
        .with(P.string.startsWith('section_link#'), () => (
          <SectionLink name={name} />
        ))
        .otherwise(() => (
          <div className="container">Unhandled CMSComponent</div>
        ))}
    </div>
  );
};

export { CMSPlaceholder };
